
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/integrations/next-js-app-router",
      function () {
        return require("private-next-pages/joy-ui/integrations/next-js-app-router.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/integrations/next-js-app-router"])
      });
    }
  